import React, { useEffect, useState } from 'react';
import { Input, Modal } from 'antd';
import axios from 'axios';
import config from '../../../config';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import MouvClientDetail from '../../mouvement/mouvementClientDetail/MouvClientDetail';
import { NdoeToolbar, NdoeResponsiveTable } from '../../../components/ndoe';
import { buildCommandeColumns, renderCommandeCard } from './commandeShared';

/**
 * Liste de commandes sur une période, générique.
 * Remplace l'ancienne duplication ListeCommandeJour / ListeCommande7jrs
 * (identiques à 95%). Paramétrée par l'endpoint.
 *
 * Props : endpoint ('commandeJour' | 'commande7' | 'commandePeriode?jours=30|90'), emptyText
 */
const CommandesPeriode = ({ endpoint = 'commandeJour', emptyText = 'Aucune commande sur cette période.' }) => {
  const DOMAIN = config.REACT_APP_SERVER_DOMAIN;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [open, setOpen] = useState(false);
  const [idClient, setIdClient] = useState({});
  const user = useSelector((state) => state.user?.currentUser);
  const isAdmin = user?.role === 'admin';

  const fetchData = async () => {
    try {
      const { data } = await axios.get(`${DOMAIN}/api/commande/${endpoint}`);
      setData(data);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [DOMAIN, endpoint]);

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${DOMAIN}/api/commande/commande/${id}`);
      fetchData();   // refetch au lieu de recharger toute la page
    } catch (err) {
      console.log(err);
    }
  };

  const showClient = (id) => { setIdClient(id); setOpen(true); };
  const handleEdit = (id) => navigate(`/Editcommande/${id}`);
  const openDetail = (id) => navigate(`/listeDetailView/${id}`);
  const openProducts = (id) => navigate(`/commandes/${id}`);

  const columns = buildCommandeColumns({
    onClient: showClient, onEdit: handleEdit, onDelete: handleDelete, isAdmin, indexOffset: 0,
  });

  const filteredData = data?.filter((item) =>
    item.nom?.toLowerCase().includes(searchValue.toLowerCase()) ||
    item.nom_statut?.toLowerCase().includes(searchValue.toLowerCase())
  );

  return (
    <>
      <NdoeToolbar
        search={
          <Input.Search
            type="search"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            placeholder="Rechercher (client, statut)…"
            allowClear
          />
        }
      />

      <NdoeResponsiveTable
        data={filteredData}
        columns={columns}
        rowKey="id_commande"
        loading={loading}
        scroll={{ x: 'max-content' }}
        pagination={{ pageSize: 15 }}
        renderCard={(record) => renderCommandeCard(record, {
          onOpen: openDetail, onProducts: openProducts, onEdit: handleEdit, onDelete: handleDelete, isAdmin,
        })}
        empty={{ icon: '🧾', title: 'Aucune commande', text: emptyText }}
      />

      <Modal title="Information de client" centered open={open} onCancel={() => setOpen(false)} width={850} footer={[]}>
        <MouvClientDetail idClients={idClient} />
      </Modal>
    </>
  );
};

export default CommandesPeriode;
